export default {
  common: {
    login: 'Вход',
    search: '',
    please: 'Пожалуйста, введите',
    noMore: 'Больше нет контента',
    loading: 'Загрузка'
    
  },
  validation: {
    emailRequired: 'Пожалуйста, введите ваш email',
    passwordRequired: 'Пожалуйста, введите ваш пароль',
    captchaRequired: 'Пожалуйста, введите код подтверждения',
    emailFormat: 'Пожалуйста, введите корректный email',
    confirmPasswordRequired: 'Пожалуйста, повторите пароль',
    nicknamePlaceholder: 'Никнейм',
    nicknameRequired: 'Пожалуйста, придумайте никнейм',
    avatarTip: 'Аватар',
    avatarRequired: 'Пожалуйста, загрузите аватар'
  },
  login: {
    emailPlaceholder: 'Введите ваш email',
    passwordPlaceholder: 'Введите пароль',
    captchaPlaceholder: 'Введите код подтверждения',
    forgot: 'Забыли пароль?',
    goRegister: 'Зарегистрироваться',
    logout: 'Выйти из системы'
  },
  register: {
    title: 'Создание аккаунта',
    emailPlaceholder: 'Введите ваш email',
    codePlaceholder: 'Введите код подтверждения',
    getCode: 'Получить код',
    passwordPlaceholder: 'Введите пароль',
    confirmPlaceholder: 'Подтвердите пароль',
    nicknamePlaceholder: 'Придумайте никнейм',
    setAvatar: 'Загрузить аватар',
    submit: 'Зарегистрироваться',
    uploading: 'Загрузка...'
  },
  forgot: {
    title: 'Восстановление пароля',
    emailPlaceholder: 'Введите ваш email',
    codePlaceholder: 'Введите код подтверждения',
    getCode: 'Получить код',
    passwordPlaceholder: 'Введите пароль',
    confirmPlaceholder: 'Подтвердите пароль',
    submit: 'Подтвердить',
    noMatch: 'Пароли не совпадают'
  },
  contact: {
    title: 'Приглашаем связаться с нами',
    infoTitle: 'Связаться с нами',
    namePlaceholder: 'Ваше имя',
    nameRequired: 'Пожалуйста, введите ваше имя',
    emailPlaceholder: 'Ваш email',
    companyPlaceholder: 'Название компании',
    phonePlaceholder: 'Ваш телефон',
    contentPlaceholder: 'Текст сообщения',
    contentRequired: '',
    captchaPlaceholder: 'Введите код подтверждения',
    submit: 'Отправить сообщение',
    submitSuccess: 'Сообщение успешно отправлено'
  },
  mine: {
    myLikes: 'Мои отметки «Нравится»'
  }
}
